import FlexContainer from '@/components/atomic/atoms/layout/flex-container/styled';
import styled from '@emotion/styled';

const Styled = styled(FlexContainer)({
	position: 'absolute',
	bottom: 0,
	width: '100%',
	height: '100%',
	background:
		'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0.14%, #000 89.82%)',
});

export default Styled;
